<kendo-dialog-titlebar
    class="mb-2 flex items-center gap-1 bg-background px-4 py-6 text-xl font-bold text-primary"
    translate
    (close)="close()">
    <div class="flex w-full items-center gap-2">
        <ng-icon name="faSolidPlus" size="25px" />
        <div class="text-lg">{{ title | translate }}</div>
    </div>
</kendo-dialog-titlebar>
<div class="flex size-full flex-col gap-2 p-3">
    <div class="grid w-full grid-cols-2 gap-2">
        <app-control
            label="Type"
            type="codelist"
            id="typeId"
            codelist="AdditionalServiceType"
            [required]="true"
            [isEditMode]="true"
            [(ngModel)]="model.typeId" />
        <app-control
            label="Status"
            type="codelist"
            id="statusId"
            codelist="AdditionalServiceStatus"
            [required]="true"
            [isEditMode]="true"
            [(ngModel)]="model.statusId" />
        <app-control label="Date from" type="datetime" [isEditMode]="true" [(ngModel)]="model.dateFrom" />
        <app-control label="Date to" type="datetime" [isEditMode]="true" [(ngModel)]="model.dateTo" />
    </div>
    <app-control label="Remark" type="textarea" [rows]="3" [isEditMode]="true" [(ngModel)]="model.remark" />
    <!-- @if (model.attachment !== null) {
        <app-control
            label="Name"
            type="string"
            [required]="true"
            [isEditMode]="true"
            [(ngModel)]="model.attachment.name" />
    } -->
    <app-control
        label="File"
        type="file"
        [multi]="false"
        [isEditMode]="true"
        [disabled]="false"
        [fileRestrictions]="{ allowedExtensions: extensions }"
        [(ngModel)]="model.attachment" />
    <kendo-dialog-actions class="flex w-full items-center gap-2">
        <div class="flex w-full items-center justify-end gap-2">
            <app-button class="w-[65px]" variant="secondary" (click)="close()">
                {{ 'Cancel' | translate }}
            </app-button>
            <app-button class="w-[70px]" variant="primary" [disabled]="!canConfirm()" (click)="confirm()">
                {{ 'Save' | translate }}
            </app-button>
        </div>
    </kendo-dialog-actions>
</div>
